import { render, staticRenderFns } from "./LargeButtonsPanel.vue?vue&type=template&id=2c7b51e4&scoped=true&"
import script from "./LargeButtonsPanel.vue?vue&type=script&lang=ts&"
export * from "./LargeButtonsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./LargeButtonsPanel.vue?vue&type=style&index=0&id=2c7b51e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b51e4",
  null
  
)

export default component.exports